import { createFileRoute, useNavigate, useParams } from '@tanstack/react-router';
import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';

import { useSubscription } from '@/features/billing';
import { Loader2 } from 'lucide-react';

const POLL_INTERVAL = 3000;
const TIMEOUT_MS = 30000;

export const Route = createFileRoute('/_authenticated/$mallId/billing/callback')({
  component: BillingCallbackPage,
});

function BillingCallbackPage() {
  const { t } = useTranslation('billing');
  const { mallId } = useParams({ from: '/_authenticated/$mallId/billing/callback' });
  const companyId = mallId ?? '';
  const navigate = useNavigate();
  const startTimeRef = useRef(Date.now());

  const { data: subscription } = useSubscription(companyId, {
    refetchInterval: POLL_INTERVAL,
  });

  useEffect(() => {
    if (!subscription) return;

    if (subscription.planId !== 'free') {
      toast.success(t('callback.success'));
      navigate({ to: '/$mallId/billing', params: { mallId: companyId } });
      return;
    }

    if (Date.now() - startTimeRef.current > TIMEOUT_MS) {
      toast.info(t('callback.timeout'));
      navigate({ to: '/$mallId/billing', params: { mallId: companyId } });
    }
  }, [subscription, navigate, companyId, t]);

  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center gap-4">
      <Loader2 className="h-10 w-10 animate-spin text-primary" />
      <p className="text-lg font-medium text-foreground">{t('callback.processing')}</p>
      <p className="text-sm text-muted-foreground">{t('callback.description')}</p>
    </div>
  );
}
